module.exports = __webpack_public_path__ + "static/img/wqx.64c30be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wqx.png
// module id = XFOy
// module chunks = 1